module.exports = __webpack_public_path__ + "img/2_253.51e9f33e.png";